import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import StoreGrid from "../components/storegrid"
import { FilterProducts } from "../helpers/product-filter"

const TowelsPage = () => (
	<Layout>
		<SEO title="Bathtime Accessories" />

		<div className="homepageBlurb">
			<h1>Bathtime Accessories</h1>
			<p>Bathtime should be a fun and relaxing time for baby, we've got all the essentials needed to help make that happen.</p>
			<p>Supersoft hooded towels and dresssing gowns to wrap baby up warm, and bright and fun toys to help baby play and splash around. Stacking / pouring cups, waterproof books and thermomers to help you make sure the water is safe. Perfect pregnancy presents, baby shower gifts, newborn baby gifts and gifts to congratulate new parents.</p>
		</div>
		
		<StoreGrid products={FilterProducts("bathtime-accessories")} />
	</Layout>
)

export default TowelsPage
